import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=185f9522&scoped=true&"
import script from "./ResourcesView.vue?vue&type=script&lang=ts&"
export * from "./ResourcesView.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesView.vue?vue&type=style&index=0&id=185f9522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f9522",
  null
  
)

export default component.exports